import { render, staticRenderFns } from "./SpecialResources.vue?vue&type=template&id=233f9d6e"
import script from "./SpecialResources.vue?vue&type=script&lang=js"
export * from "./SpecialResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports